<template>
    <!-- <div class="vx-row">
        <vs-list v-for="(item, index) in getAllEmployeeSchedule">
             <vs-list-header v-if="index == 0" :title="item.user.fullName"></vs-list-header>
                    <vs-list-item :title="item.scheduleDate | fulldate" subtitle="t" >{{item.scheduleIn | time}} - {{item.scheduleOut | time}}</vs-list-item>
        </vs-list>
    </div>     -->
    <div  class="vx-row">
                <vx-card title="Verify Schedule">
                    <vs-table :data="getAllEmployeeSchedule" v-model="selected"    stripe pagination :max-items="10" search   >
                        <template slot="thead">
                            <vs-th sort-key="employeeCode">Code</vs-th>
                            <vs-th sort-key="fullName">Name</vs-th>
                            <vs-th sort-key="scheduleDate">Schedule Date</vs-th>
                            <vs-th>Day</vs-th>
                            <vs-th>Schedule In</vs-th>
                            <vs-th>Schedule Out</vs-th>
                            <vs-th>Shift Type</vs-th>
                            <vs-th>Schedule Type</vs-th>
                            <vs-th>Actions</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].user.employeeCode">
                                    {{ data[indextr].user.employeeCode }}
                                </vs-td>
                                <vs-td :data="data[indextr].user.fullName">
                                    {{ data[indextr].user.fullName }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleDate">
                                    {{ data[indextr].scheduleDate | fulldate }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleDate">
                                    {{ getDayName(data[indextr].scheduleDate) }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleIn">
                                    {{ data[indextr].scheduleIn | time }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleOut">
                                    {{ data[indextr].scheduleOut | time }}
                                </vs-td>
                                <vs-td :data="data[indextr].shiftTypeId">
                                    {{ shiftTypeName(data[indextr].shiftTypeId).shiftTypeName }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleTypeId">
                                    <span class="flex items-center px-2 py-1 rounded"><div v-bind:class="
                                    data[indextr].scheduleTypeId == 1 ? 'h-3 w-3 rounded-full mr-2 bg-success' :
                                    data[indextr].scheduleTypeId == 2 ? 'h-3 w-3 rounded-full mr-2 bg-danger' : 'h-3 w-3 rounded-full mr-2 bg-warning'"/>
                                    {{ scheduleTypeName(data[indextr].scheduleTypeId).scheduleTypeName}}
                                    </span>
                                </vs-td>
                                <vs-td>
                                    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                        <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                        <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
</template>
<script>
import moment from 'moment'
export default {
    props: {
        createSchedule: {
            type: Object,
            required: false
        },
        isValidate3: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            selected: []

        }
    },
    watch: {
        isValidate3(value) {
            if(value) {
                const data = {
                createScheduleId: this.createSchedule.createScheduleId,
                scheduleNumberId: this.createSchedule.scheduleNumberId, 
                userId: this.$store.state.AppActiveUser.uid 
                }
                this.$store.dispatch('hrms/getAllEmployeeScheduleByCreateScheduleId', data)
            }
          
        }
    },
    created() {
        

    },
    computed: {
        getAllEmployeeSchedule() {
            return this.$store.getters['hrms/getEmployeeScheduleIfNotPosted']()//this.$store.state.hrms.getAllEmployeeSchedule
        },
        shiftTypeName() {
            return (shiftTypeId) => this.$store.getters['lookup/shiftTypeLookup'](shiftTypeId)
        },
        scheduleTypeName() {
            return (scheduleTypeId) => this.$store.getters['lookup/scheduleTypeLookup'](scheduleTypeId)
        },
        getDayName() {
            return (date) => moment(date).format('dddd')
        }
        // getAllEmployeeSchedule: {
        //     get() { return this.$store.state.getAllEmployeeSchedule },
        //     set(value) { 
        //         const data = {
        //         createScheduleId: value, 
        //         userId: this.$store.state.AppActiveUser.uid 
        //         }
        //     this.$store.dispatch('schedule/getAllEmployeeScheduleByCreateScheduleId', data)}
        // },
    }
    
}
</script>